<template>
    <div class="white-container">
        <h2>{{$t('profile.LBL_EDIT_PROFILE_HEADER')}}</h2>
        <div class="profile-form" style="margin-top:60px;">
            <div class="primary">
                <div class="primary-wrapper">
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_FIRST_NAME')}}</label>
                        <div class="input-wrapper">
                            <input type="text" v-model="profile.first_name"/>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_LAST_NAME')}}</label>
                        <div class="input-wrapper">
                            <input type="text" v-model="profile.last_name"/>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_PHONE')}}</label>
                        <div class="input-wrapper">
                            <input type="text" v-model="profile.phone"/>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_DOB')}}</label>
                        <div class="input-wrapper">
                            <div class="dob-wrapper">
                                <DropDown
                                :options="days()"
                                :selected="dob_day"
                                v-model="dob_day"
                                ></DropDown>
                                <DropDown
                                :options="months()"
                                :selected="dob_mon"
                                v-model="dob_mon"
                                ></DropDown>
                                <DropDown
                                :options="years()"
                                :selected="dob_year"
                                v-model="dob_year"
                                ></DropDown>
                            </div>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_SKYPE')}}</label>
                        <div class="input-wrapper">
                            <input type="text" v-model="profile.skype"/>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_GENDER')}}</label>
                        <div class="input-wrapper">
                            <DropDown
                                :options="genders()"
                                :selected="profile.gender"
                                v-model="profile.gender"
                            ></DropDown>
                        </div>
                    </div>
                </div>
            </div>
            <div class="secondary">
                <div class="secondary-wrapper">
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_EMAIL')}}</label>
                        <div class="input-wrapper">
                            <input disabled type="text" v-model="profile.email"/>
                        </div>
                        <FieldButton v-if="!forms.email.display" :label="$t('strings.BTN_CHANGE')" secondary :click="()=>{forms.email.display=true;}"></FieldButton>
                        <div v-if="forms.email.display" class="field-wrapper" style="margin-bottom: 40px;">
                            <div class="field-wrapper">
                                <label>{{$t('profile.LBL_NEW_EMAIL')}}</label>
                                <div class="input-wrapper">
                                    <input type="text" v-model="forms.email.new" />
                                </div>
                            </div>
                            <div class="field-wrapper">
                                <label>{{$t('profile.LBL_CONFIRM_NEW_EMAIL')}}</label>
                                <div class="input-wrapper">
                                    <input type="text" v-model="forms.email.confirm" />
                                </div>
                            </div>
                            <FieldButton :label="$t('strings.BTN_SAVE')" :click="()=>{update_email()}" :disabled="!update_email_validated" :loading="forms.email.save"></FieldButton>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label>{{$t('profile.LBL_CURRENT_PASSWORD')}}</label>
                        <div class="input-wrapper">
                            <input disabled type="password" v-model="profile.password"/>
                        </div>
                        <FieldButton v-if="!forms.password.display" :label="$t('strings.BTN_CHANGE')" secondary :click="()=>{forms.password.display=true;}"></FieldButton>
                        <div v-if="forms.password.display" class="field-wrapper" style="margin-bottom: 40px;">
                            <div class="field-wrapper">
                                <label>{{$t('profile.LBL_NEW_PASSWORD')}}</label>
                                <div class="input-wrapper">
                                    <input type="password" v-model="forms.password.new" />
                                </div>
                            </div>
                            <div class="field-wrapper">
                                <label>{{$t('profile.LBL_CONFIRM_NEW_PASSWORD')}}</label>
                                <div class="input-wrapper">
                                    <input type="password" v-model="forms.password.confirm" />
                                </div>
                            </div>
                            <FieldButton :label="$t('strings.BTN_SAVE')" :click="()=>{update_password()}" :disabled="!update_password_validated" :loading="forms.password.save"></FieldButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="middle-wrapper" style="margin-top:30px">
            <FieldButton :label="$t('strings.BTN_SAVE')" :click="()=>{update()}" :loading="load"></FieldButton>
        </div>
        <ErrorPopup 
            :show="display_error" 
            :popup_header="error.title" 
            :popup_description="error.description" 
            v-on:closeEvent="display_error=false"
            :buttons="error.buttons"
        />
    </div>
</template>
<style lang="scss">
    .profile-form{
        display:flex;
        >.primary{
            width:100%;
            flex:1;
            .primary-wrapper{
                max-width: 460px;
            }
            .dob-wrapper{
                display: flex;
                &>*{
                    margin-right: 20px;
                    &:last-child{
                        margin-right: 0px;
                    }
                    &:nth-child(1){
                        width: 100%;
                        max-width: 100px;
                    }
                    &:nth-child(2){
                        width:100%;
                        flex:1;
                    }
                    &:nth-child(3){
                        width: 100%;
                        max-width: 120px;
                    }
                }
            }
            .field-wrapper .input-wrapper input{
                max-width: 100%;
            }
        }
        >.secondary{
            max-width: 600px;    
            width: 100%;
            min-width: 300px;
            padding-left:40px;
        }
    }
</style>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import {rest} from '@/utils/utils';
    import i18n from '@/i18n';
    import ErrorPopup from "@/views/pages/manager_popups/ErrorPopup";
    import {FieldButton,DropDown} from "@/components/fields/fields";
    import lStorage from '../../../store/localStorage';

    export default {
        name:'Profile',
        components:{
            ErrorPopup,
            FieldButton,
            DropDown
        },
        data:function(){
            return{
                display_error:false,
                profile:{
                    first_name:"",
                    last_name:"",
                    phone:"",
                    email:"",
                    dob:"",
                    audio:true,
                    skype:"",
                    gender:"",
                    password:"password"
                },
                display_error:false,
                error:{
                    title:"",
                    description:"",
                    buttons:[]
                },
                forms:{
                    email:{
                        display:false,
                        save:false,
                        new:"",
                        confirm:""
                    },
                    password:{
                        display:false,
                        save:false,
                        new:"",
                        confirm:""
                    }
                },
                load:false,
                dob_year:null,
                dob_mon:null,
                dob_day:null
            }
        },
        mounted(){
            //Загрузим информацию о пользователе
            store.commit('loading/is', true);
            this.isLoad = false;
            //Получим товары из предложения
            rest.call("get_profile",{},"GET").then((response)=>{
                this.isLoad = true;
                store.commit('loading/is', false);
                if(response.status && response.status == "ok" && response.data){
                    this.profile = Object.assign({
                        password:"password"
                    },response.data);
                }
            }).catch((error)=>{
                this.isLoad = true;
                store.commit('loading/is', false);
            });
        },
        methods:{
            update(){
                //Проверяем обязательные поля
                if(!this.email_validated){
                    this.display_error = true;
                    this.error = {
                        title:i18n.t('profile.LBL_EMAIL_NOT_PASSED'),
                        description:i18n.t('profile.LBL_EMAIL_NOT_PASSED_DESCRIPTION'),
                        buttons:[]
                    };
                    return;
                }
                if(!this.profile.first_name || !this.profile.last_name || this.profile.first_name.toString().trim().length==0||this.profile.last_name.toString().trim().length==0){
                    this.display_error = true;
                    this.error = {
                        title:i18n.t('profile.LBL_NAME_NOT_PASSED'),
                        description:i18n.t('profile.LBL_NAME_NOT_PASSED_DESCRIPTION'),
                        buttons:[]
                    };
                    return;
                }
                //Все ок - обновляем профиль
                store.commit('loading/is', true);
                //Получим товары из предложения
                var data = Object.assign({},this.profile,{
                    email:null,
                    password:null,
                    dob:this.date_of_birth
                });
                this.load = true;
                rest.call("update_profile",{data:data},"GET").then((response)=>{
                    store.commit('loading/is', false);
                    this.load = false;
                    if(response.status && response.status == "ok"){
                        this.$router.push({
                            name:"Profile",
                            params:{
                                locale:i18n.locale,
                            }
                        });
                    }else{
                        this.display_error = true;
                        this.error = {
                            title:i18n.t('profile.LBL_ERROR_UPDATING_PROFILE'),
                            description:i18n.t('soap.'+response.number),
                            buttons:[]
                        };
                        return;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                    this.load = false;
                });
            },
            update_email(){
                this.forms.email.save=true;
                store.commit('loading/is', true);
                //Получим товары из предложения
                rest.call("update_profile",{data:{
                    email:this.forms.email.confirm
                }},"GET").then((response)=>{
                    store.commit('loading/is', false);
                    this.forms.email.save=false;
                    if(response.status && response.status == "ok"){
                        this.profile.email=this.forms.email.confirm;
                        this.forms.email.display = false;
                    }else{
                        this.display_error = true;
                        this.error = {
                            title:i18n.t('profile.LBL_ERROR_UPDATING_PROFILE'),
                            description:i18n.t('soap.'+response.number),
                            buttons:[]
                        };
                        return;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                    this.forms.email.save=false;
                });
            },
            update_password(){
                this.forms.password.save=true;
                store.commit('loading/is', true);
                //Получим товары из предложения
                rest.call("update_profile",{data:{
                    password:this.forms.password.confirm,
                    to_email:this.profile.email
                }},"GET").then((response)=>{
                    store.commit('loading/is', false);
                    this.forms.password.save=false;
                    if(response.status && response.status == "ok"){
                        this.forms.password.display = false;
                    }else{
                        this.display_error = true;
                        this.error = {
                            title:i18n.t('profile.LBL_ERROR_UPDATING_PROFILE'),
                            description:i18n.t('soap.'+response.number),
                            buttons:[]
                        };
                        return;
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                    this.forms.password.save=false;
                });
            },
            days(){
                var list = [];
                var i = 1;
                while(i<32){
                    var d = i.toString();
                    if(d.length == 1) d = "0"+d;
                    list.push({
                        value:d,
                        label:d
                    });
                    i+=1;
                }
                return list;
            },
            months(){
                var list = [];
                var i = 1;
                while(i<13){
                    var m = i18n.t("strings.MONTH_"+i);
                    var m = m.charAt(0).toUpperCase() + m.slice(1);
                    var k = i < 10?"0"+i.toString():i.toString();
                    list.push({
                        value:k,
                        label:m
                    });
                    i+=1;
                }
                return list;
            },
            years(){
                var list = [];
                var i = 0,
                d = new Date();
                var y = d.getFullYear();
                while(i<100){
                    var l = parseInt(y) - i;
                    list.push({
                        value:l,
                        label:l.toString()
                    });
                    i+=1;
                }
                return list;
            },
            genders(){
                var list = [],
                options = i18n.t("lists.genders_list");
                for(var x in options){
                    list.push({
                        value:x,
                        label:options[x]
                    });
                }
                return list;
            }
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
            url_prefix(){
                return (i18n.locale=="ro"?"":"/"+i18n.locale);
            },
            email_validated(){
                return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.profile.email)==true;
            },
            update_email_validated(){
                if(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.forms.email.new)==false){
                    return false;
                }
                if(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.forms.email.confirm)==false){
                    return false;
                }
                if(this.forms.email.confirm != this.forms.email.new) return false;
                return true;
            },
            update_password_validated(){
                if(this.forms.password.confirm != this.forms.password.new) return false;
                return true;
            },
            date_of_birth(){
                return this.dob_year+"-"+this.dob_mon+"-"+this.dob_day;
            }
        },
        watch:{
            "profile.dob"(){
                if(this.profile.dob){
                    var d = new Date(this.profile.dob);
                    if(d){
                        this.dob_year = d.getFullYear().toString();
                        this.dob_mon = (d.getMonth()+1).toString();
                        this.dob_day = d.getDate().toString();

                        if(parseInt(this.dob_mon) < 10) this.dob_mon = "0" + this.dob_mon;
                        if(parseInt(this.dob_day) < 10) this.dob_day = "0" + this.dob_day;
                    }
                }
            }
        }
    }
</script>